import { createAction } from 'redux-actions';
import * as Actions from '../constants/actions';
import { UserData, OptionalUserData } from '../models/User';

export const loginUser = createAction<UserData>(Actions.USER_LOGIN);
export const registerUser = createAction<{user: UserData, code: string}>(Actions.USER_REGISTER);
export const authenticateUser = createAction<UserData>(Actions.USER_AUTHENTICATE);
export const updateUser = createAction<OptionalUserData>(Actions.USER_UPDATE);


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/actions/users.ts